module.exports = __webpack_public_path__ + "media/images/escudo_peru-5e97eeda00d622682b62bc40a26de675.svg";